/**
 * Auth via HttpOnly cookies — no Bearer token in headers.
 * CSRF is attached globally by httpClient interceptors for mutating requests.
 */
export function getApiHeaders() {
    return {};
}

export default getApiHeaders;
